import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";

import { Table } from "../../../../../components/table/Table";
import { getOnlineDevicesForTable } from "../../../../../store/devices/devices.selectors";
import { Mobile, NotMobile } from "../../../../../hocs/Responsive";
import { useIntlTranslate } from "../../../../../hooks";
import {
  COLUMNS,
  COLUMNS_MOBILE,
  SEARCH_KEYS,
} from "./OnlineDevicesTable.consts";
import { OnlineDevicesTableHeader } from "./components";

export const OnlineDevicesTable = () => {
  const devices = useSelector(getOnlineDevicesForTable, _.isEqual);
  const translate = useIntlTranslate();
  const caption = translate("online");

  return (
    <Fragment>
      <Mobile>
        <Table
          header={<OnlineDevicesTableHeader />}
          searchKeys={SEARCH_KEYS}
          showPagination
          visibleHeader={false}
          data={devices}
          columns={COLUMNS_MOBILE}
          hiddenColumns={["manufacturer"]}
          searchAriaLabelMessage="aria_search_for_device"
          caption={caption}
        />
      </Mobile>
      <NotMobile>
        <Table
          header={<OnlineDevicesTableHeader />}
          searchKeys={SEARCH_KEYS}
          showPagination
          data={devices}
          columns={COLUMNS}
          searchAriaLabelMessage="aria_search_for_device"
          caption={caption}
        />
      </NotMobile>
    </Fragment>
  );
};
